import { render } from "./searchPage.vue?vue&type=template&id=452279c6&scoped=true"
import script from "./searchPage.vue?vue&type=script&lang=js"
export * from "./searchPage.vue?vue&type=script&lang=js"

import "./searchPage.vue?vue&type=style&index=0&id=452279c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452279c6"]])

export default __exports__